import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Movie from "../components/Movie";
import { getFavorites, toggleFavorite } from "../utils/favorites";

function Favorites() {
  // localStorage에서 읽은 즐겨찾기 원본 목록
  const [favorites, setFavorites] = useState([]);
  // 화면 정렬 기준: latest / rating / year
  const [sort, setSort] = useState("latest");

  // 즐겨찾기 목록을 다시 불러와 화면과 동기화한다.
  const loadFavorites = () => setFavorites(getFavorites());

  useEffect(() => {
    // 다른 화면에서 즐겨찾기가 바뀌면 즉시 목록을 갱신한다.
    loadFavorites();
    const onFavoritesUpdated = () => loadFavorites();
    window.addEventListener("favorites-updated", onFavoritesUpdated);
    return () => window.removeEventListener("favorites-updated", onFavoritesUpdated);
  }, []);

  const sortedFavorites = useMemo(() => {
    // 원본 배열 변형을 피하기 위해 복사 후 정렬한다.
    const list = [...favorites];
    if (sort === "rating") {
      list.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    } else if (sort === "year") {
      list.sort((a, b) => (b.year || 0) - (a.year || 0));
    }
    return list;
  }, [favorites, sort]);

  // 즐겨찾기 화면에서도 바로 제거/추가가 가능하도록 토글 제공
  const onToggleFavorite = (movieId) => {
    const target = favorites.find((movie) => movie.id === movieId);
    if (!target) return;
    toggleFavorite(target);
    loadFavorites();
  };

  return (
    <div className="page">
      <header className="topbar">
        <h1>My Favorites</h1>
        <Link className="link-btn" to="/">
          Back to Home
        </Link>
      </header>

      <section className="control-panel">
        <select value={sort} onChange={(event) => setSort(event.target.value)}>
          <option value="latest">Sort by latest added</option>
          <option value="rating">Sort by rating</option>
          <option value="year">Sort by year</option>
        </select>
      </section>

      {/* 데이터 분기: 비어있으면 안내, 아니면 카드 목록 */}
      {sortedFavorites.length === 0 ? (
        <section className="state-box">
          <h2>No favorites yet</h2>
          <p>Mark movies with the star button to save them here.</p>
        </section>
      ) : (
        <section className="movie-grid">
          {sortedFavorites.map((movie) => (
            <Movie
              key={movie.id}
              id={movie.id}
              coverImg={movie.medium_cover_image}
              title={movie.title}
              summary={movie.summary}
              genres={movie.genres}
              rating={movie.rating}
              year={movie.year}
              isFavorite
              onToggleFavorite={onToggleFavorite}
            />
          ))}
        </section>
      )}
    </div>
  );
}

export default Favorites;
